module.exports = __webpack_public_path__ + "static/img/bg-4.d9bc1a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgaofu/bnaner/bg-4.png
// module id = uc3n
// module chunks = 0